import styled from 'styled-components';
import { Link as LinkRouter } from '@reach/router';
import breakpoint from '../breakpoints';

export const SubcategoriesWrapper = styled.div`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  ${breakpoint('tablet')}{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ${breakpoint('mobile')} {
    display: block;
    padding-top: 10px;
    height: 40px;
    overflow-x: scroll;
  }
`

export const Heading = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 15px;
  width: 100%;
`

export const Subcategories = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  height: 38px;
  ${breakpoint('tablet', 'up')} {
    justify-content: center;
    overflow: hidden;
  }
`

export const Category = styled(LinkRouter)`
  font-weight: bold;
  padding-top: 5px;
  margin: 5px 40px 0 5px;
  color: black;
  text-decoration: none;
  word-break: keep-all;
  &:visited {
    color: black;
  }
  &.active {
    color: #b92a2e;
    border-bottom: 3px solid #b92a2e;
  } 
  ${breakpoint('tablet', 'down')} {
    margin: 5px 20px 0 5px;
    width: 100%;
  }
  ${breakpoint('mobile', 'down')} {
    :first-of-type {
      margin-left: 15px;
    }
  }
  @media (hover) {
    &:hover {
      color: #b92a2e;
      border-bottom: 3px solid #b92a2e;
      transition: 0.1s;
    }
  }
`

export const Title = styled.h3`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 10px;
  ${breakpoint('tablet', 'up')} {
    font-size: 25px;
    line-height: 1.5;
  }
  ${breakpoint('mobile', 'up')} {
    text-align: center;
    line-height: 1.6;
  }
`

export const GridWrapper = styled.div`
  text-align: center;
  background-color: #f1f1f1;
`
export const MainDescription = styled.div`
  font-family: "ToyotaType Book";
	font-size: 15px;
	line-height: 20px;
	letter-spacing: 0.05em;
  background-color: #f1f1f1;
  display: flex;
  justify-content: center;
  text-align: center;
  height: auto;
  padding: 23px 0 10px;
`

export const DescriptionContent = styled.span`
  width: 45%;
  ${breakpoint('mobile', 'down')} {
    width: 90%;
  }
`